module.exports = __webpack_public_path__ + "img/img6.50335d01.jpg";